<template>
  <div id="app">

  <div v-if="$store.state.isConnected">
    <notifications group="newcar" />
      <div id="header">
        <a href="#" id="backhome"><i class="fa fa-car" aria-hidden="true"></i> CARGENIC APP </a>
        <nav id="navigation">
          <router-link v-if="$store.state.auth.profile.role == 'admin' || $store.state.auth.profile.rights.indexOf('inbox') != -1 " :to="{ name: 'Cars' }">Eingang</router-link>
          <router-link v-if="$store.state.auth.profile.role == 'admin' || $store.state.auth.profile.rights.indexOf('users') != -1 " to="/users">Nutzer</router-link>
          <router-link v-if="$store.state.auth.profile.role == 'admin' || $store.state.auth.profile.rights.indexOf('websites') != -1" to="/manageproperties">Websites</router-link>
          <router-link v-if="$store.state.auth.profile.role == 'admin' || $store.state.auth.profile.rights.indexOf('dat') != -1" to="/datfastrequest">DAT Schnellabfrage</router-link>
          <router-link v-if="$store.state.auth.profile.role == 'admin' || $store.state.auth.profile.rights.indexOf('cities') != -1" to="/cities">Städte</router-link>
  <!--      <router-link to="/todo">TodoListView</router-link>  -->
<!--      <router-link to="/hello">Telefon</router-link>  -->
        </nav>
<!--         <a href="#" id="openchat" v-on:click="toggleOpenChat"><i class="fa fa-comments" aria-hidden="true"></i></a> -->
<!--         <chat-view></chat-view> -->
        <a href="#" id="toggleMenu"><i class="fa fa-bars" aria-hidden="true"></i></a>
        <div id="metanav">
          <a href="#" id="userprofile"><i class="fa fa-user-circle-o" aria-hidden="true"></i><span>{{$store.state.auth.username}}</span></a>
          <a href="#" id="logout" v-on:click="logout"><i class="fa fa-sign-out" aria-hidden="true"></i><span>Logout</span></a>
        </div>

<!--         <i-listen-to-sockets></i-listen-to-sockets>	     -->

      </div>
<!-- 		<footer id="footer"></footer> -->
    </div>
    <router-view></router-view>
<!--     <chat-view id="chat">chat</chat-view> -->
  </div>
</template>

<script>
//import sweetalert from 'sweetalert';
import ChatView from '@/components/Chat/ChatView';
import IListenToSockets from '@/components/IListenToSockets/IListenToSockets';

export default {
  name: 'app',
  components: {
    ChatView,
    IListenToSockets,
  },
  // get websocket status
  created: function(){

    var $this = this;
    this.$socket.on('connect', function(){
      //console.log(this);
      //console.log($this.$socket);
      console.log('now connect and auth');
      $this.$store.state.isConnected = true
      this.emit('authenticate', { token: $this.$store.state.auth.token });
    })
    this.$socket.on('disconnect', function(){ $this.$store.state.isConnected = false; $this.logout() });
    this.loggedIn();


  },

  methods: {
    
    loggedIn () {
    var $this = this
    //	console.log('app.vue mounted')
    //console.log('check Login State: ')
    //console.log( this.$store.state.auth );
    
    var st = this.$store.state.auth && this.$store.state.isConnected;
    console.log( this.$store.state.auth );  
    console.log( this.$store.state.isConnected ) 
    console.log( 'st ' + st );    
    if(!st) this.$router.replace('/login')
    else { 
      
				  	var newRoute = '/cars';
				  	if( this.$store.state.auth.profile.role == 'dat' ) {
  				  	this.$store.state.currentRoute = "";
				  	  newRoute = '/datfastrequest';
				  	  }

              //console.log('loading new route ' + this.$store.state.currentRoute );
      
      this.$router.replace( this.$store.state.currentRoute != "" ? this.$store.state.currentRoute  : newRoute ); 
      this.$socket.connect({ query: {token: $this.$store.state.auth.token } });
    }
      return st;
    },

    logout(){
    //console.log(this.$store.state.auth)
    this.$store.state.auth = null
    this.$store.state.isConnected = false
    //console.log('logged out');
    //console.log( this.$store.state.auth );
    //console.log(this.$router)
    //var st = this.$store.state.auth.loggedin && this.$store.state.isConnected;  
    //this.$store.state.isConnected = false
    this.$socket.close();

    //console.log( this.$store.state.auth) 
    
    //this.$session.destroy();
    //this.$router.replace('/login')
    
//this.$store.dispatch('logout').then(() => {
  console.log( 'clearing storage' );
   window.localStorage.clear();
   this.$router.push('/login');
//});    
    
    
    //this.$router.push("Login")// : this.$router.replace('/cars');	 
    //router.push('/login') 
  },
  toggleOpenChat(e){
  e.preventDefault();
  e.currentTarget.classList.toggle("active");  
  },
  closeChat(){
  $('#openchat').removeClass('active');
  }
  }
/*
  sockets: {
  carNotification(n) {
    this.$notify({
    group: 'newcar',
    title: (n.count > 1 ? 'Update' : 'Neue Anfrage'),
    text: n.car,
    duration: 30000,
    position: 'top center'
    });

    }
  }
*/


}
</script>

<style lang="scss" scoped>
  @import './assets/css/app.css'
</style>
